import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SampleCard from './SampleCard';
import ProductService from '../services/productService';
import { getImageUrl } from '../services';
import { productPrice, variantPrice, productDiscountPercent } from '../utils/productPrice';
import { orderedProductImages } from '../utils/variants';

const SampleSection = ({ hideHeader = false }) => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchSamples = async () => {
      try {
        const data = await ProductService.getProducts({
          paginate: 10,
          activated: 1,
          type: 'sample',
        });

        const raw = Array.isArray(data)
          ? data
          : (Array.isArray(data?.data) ? data.data : []);

        setProducts(raw);
      } catch (err) {
        console.error('Erreur lors du chargement des échantillons:', err);
      }
    };

    fetchSamples();
  }, []);

  const handleNavigate = () => {
    navigate('/listEchantillon');
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleNavigate();
    }
  };

  const handleSampleClick = (sampleId) => {
    navigate(`/echantillonDetails/${sampleId}`);
  };

  const mapToCardSample = (p) => {
    if (!p) {
      return {
        id: null,
        image: ['/img/pro/default.png'],
        price: 0,
        name: 'Échantillon',
      };
    }

    let sampleInfo = p.sample || {};

    if ((!sampleInfo || Object.keys(sampleInfo).length === 0) && Array.isArray(p.variants)) {
      const variantWithSample = p.variants.find((v) => v && v.sample);
      if (variantWithSample && variantWithSample.sample) {
        sampleInfo = variantWithSample.sample;
      }
    }

    const salePrice = variantPrice(sampleInfo) || productPrice(p, 'sample');
    const discount = productDiscountPercent(p, 'sample');

    // Galerie du produit d'abord, photos des combinaisons ensuite.
    const images = orderedProductImages(p);

    const imageArray = images
      .map((img) => getImageUrl(img.url || img.path))
      .filter(Boolean);

    return {
      id: p.id,
      image: imageArray.length > 0 ? imageArray : ['/img/pro/default.png'],
      price: salePrice || 0,
      name: p.label || p.reference || p.slug || 'Échantillon',
      discountPercent: discount,
    };
  };

  const normalizedSamples = Array.isArray(products)
    ? products.map(mapToCardSample)
    : [];

  return (
    <section className="bg-white overflow-hidden pb-2">
      {!hideHeader && (
        <div className="flex items-center justify-between px-3 pt-3 pb-1">
          <h2 className="text-sm font-bold text-gray-800">Échantillons</h2>
          <button
            className="text-xs text-orange-500 font-medium"
            onClick={handleNavigate}
            onKeyDown={handleKeyDown}
            aria-label="Voir plus d'échantillons"
            tabIndex={0}
          >
            Voir plus
          </button>
        </div>
      )}
      <p className="text-[11px] text-gray-400 px-3 mb-2">Disponibles immédiatement</p>
      <div className="flex overflow-x-auto space-x-2 scrollbar-hide pl-3 pr-3">
        {normalizedSamples.map((sample) => (
          <div key={sample.id} onClick={() => handleSampleClick(sample.id)}>
            <SampleCard
              id={sample.id}
              image={sample.image}
              price={sample.price}
              name={sample.name}
              discountPercent={sample.discountPercent}
            />
          </div>
        ))}
      </div>
    </section>
  );
};

export default SampleSection;
